import type { Id } from '@odhaczka/core';
import { db } from '../db/db';

/** Meta (bez synchronizacji): produkty, o których miejsce w danym sklepie pytaliśmy już AI → kiedy. */
export const triedKey = (storeId: Id) => `aiPlaceTried:${storeId}`;

/** Reset albo kopia trasy kasuje zgadnięte miejsca — produkty mogą zostać umieszczone ponownie. */
export async function forgetPlacementTries(storeId: Id): Promise<void> {
  await db.meta.delete(triedKey(storeId));
}
